/**
 *
 * key
 *
 */

 const key = 'bGVhdmVPcHRpb25z'

 export default key
 